export const siemProtocolOptions = [
  { value: 1, label: 'TCP' },
  { value: 2, label: 'UDP' },
]
export const siemLogFormatOptions = [
  { value: 1, label: 'CEF (Arcsight)' },
  { value: 2, label: 'Key-Value (Splunk)' },
  { value: 3, label: 'LEEF (QRadar)' },
]
export const timezoneOptions = require('utils/timezones.json').map((tz) => ({
  value: tz,
  label: tz,
}))
export const countryOptions = require('./countries.json').map((country) => ({
  value: country,
  label: country,
}))

export const markAsSpamActionOptions = [
  { value: 10, label: 'Do nothing' },
  { value: 2, label: 'Move to spam folder' },
  { value: 1, label: 'Move to quarantine' },
]
export const serverSideTypes = [
  { value: 0, text: 'None' },
  { value: 1, text: 'Exchange' },
  { value: 2, text: 'Gmail' },
]
export const exchangeAccessTypes = [
  { value: 0, label: 'Delegate' },
  { value: 1, label: 'Impersonation' },
]
export const workingDaysOptions = [
  { value: 1, label: 'Monday - Friday' },
  { value: 2, label: 'Sunday - Thursday' },
]
